import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "temp",
  "use": "temp-usage",
  "viewBox": "0 0 8.1 20",
  "content": "<symbol viewBox=\"0 0 8.1 20\" id=\"temp\">\n<title>temp</title>\n<path d=\"M6.4,12.8V2.4C6.4,1.1,5.4,0,4.1,0C2.8,0,1.7,1.1,1.7,2.4v10.5C0.7,13.5,0,14.7,0,16c0,2.2,1.8,4,4,4s4-1.8,4-4\n\tC8.1,14.7,7.5,13.5,6.4,12.8L6.4,12.8z M4.1,19.1c-1.7,0-3.1-1.4-3.2-3.1c0,0,0,0,0,0c0-1.1,0.6-2,1.5-2.6l0.2-0.1V2.3\n\tc0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v10.9l0.2,0.1c0.9,0.6,1.4,1.5,1.4,2.6C7.2,17.7,5.8,19.1,4.1,19.1\n\tC4.1,19.1,4.1,19.1,4.1,19.1z\" />\n<path d=\"M4.5,14.6V5.9H3.6v8.6C3,14.7,2.5,15.3,2.5,16c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C5.6,15.3,5.2,14.7,4.5,14.6\n\tL4.5,14.6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/temp.svg
// module id = 8bpX
// module chunks = 264